module.exports = __webpack_public_path__ + "static/media/tn-mpants-knee-wide.5cba1cf5.svg";